import { render, staticRenderFns } from "./BaseCardTitle.vue?vue&type=template&id=9b56b01c&scoped=true&"
import script from "./BaseCardTitle.vue?vue&type=script&lang=js&"
export * from "./BaseCardTitle.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardTitle.vue?vue&type=style&index=0&id=9b56b01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b56b01c",
  null
  
)

export default component.exports